export default __webpack_public_path__ + "8e9677f1b97867802fdd788f7b8808b4.png";